<template>
    <div class="sr-data-placeholder d-flex flex-column align-center">
        <SrIcon disabled size="xxl" :icon="icon" />
        <h3 class="gray-darkest--text mt-4 mb-4 sr-data-placeholder--title">
            {{ title }}
        </h3>
        <p class="gray-darkest--text sr-data-placeholder--text">
            {{ text }}
        </p>
        <slot />
    </div>
</template>

<script>
import { SrIcon } from '../SrIcon';

export default {
    name: 'SrDataPlaceholder',
    components: { SrIcon },
    props: {
        title: {
            type: String,
            default: 'Title',
        },
        text: {
            type: String,
            default: 'Text',
        },
        icon: {
            type: String,
            default: 'campaign',
        },
    },
};
</script>
